import PageLayoutRequests from '../../server/pageLayout';
import { addLoading, removeLoading } from './loading';

export const updatePageLayout = (pageLayout) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await PageLayoutRequests.updatePageLayout(pageLayout);
  } finally {
    dispatch(removeLoading());
  }
};

export const getPageLayout = (pageLayoutId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await PageLayoutRequests.getPageLayout(pageLayoutId);
  } finally {
    dispatch(removeLoading());
  }
};
